import TypographyPro from 'themes/TypographyPro'
import { StyledAddressLabelButtonContainer, StyledAddressLabelIcon } from './AddressLabelButton.styles'

interface AddressLabelButtonProps {
	onClick: () => void
	selected: boolean
	text: string
	iconUrl: string
}
const AddressLabelButton = ({ onClick, selected, text, iconUrl }: AddressLabelButtonProps) => (
		<StyledAddressLabelButtonContainer onClick={onClick} selected={selected}>
			<StyledAddressLabelIcon asset={iconUrl} />
			<TypographyPro variant='BodyRegularHighlighted'>
				{text}
			</TypographyPro>
		</StyledAddressLabelButtonContainer>
	)

export default AddressLabelButton
